export const forceWindowResize = (timeout: number = 200): void => {
  const event = document.createEvent('Event');
  event.initEvent('resize', false, true);
  setTimeout(() => { window.dispatchEvent(event); }, timeout);
};